jQuery(document).ready(function () {
    const status = jQuery('.slider__paging-info');
    const slickElement = jQuery(".slider__slides");

    //this sets the '1 of 2' etc label on the homepage slider
    slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        let i = (currentSlide ? currentSlide : 0) + 1;
        status.text(i + ' of ' + slick.slideCount);
    });

    // this is the functionality for the sliders captions, they need to be done separately
    slickElement.slick({
        asNavFor: '.slider-captions',
        infinite: true,
        speed: 200,
        arrows: false

    })
    // this is the functionality for the sliders images
    jQuery(".slider-captions").slick({
        asNavFor: '.slider__slides',
        infinite: true,
        speed: 200,
        fade: true,
        appendArrows: jQuery('.slider-pagination'),
        prevArrow: '<div class="pagination__button prev"></div>',
        nextArrow: '<div class="pagination__button next"></div>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    })
});